import { Field, Form, Formik } from "formik"
import useTranslation from "next-translate/useTranslation"

import { IPasswordResetRequest } from "@api/schema"
import { FormButtonArea } from "@components/common/form/FormButtonArea"
import FormikInput from "@components/common/form/FormikInput"
import GeneralFormError from "@components/common/form/GeneralFormError"

interface IProps {
  onSubmit: (...args: any) => void
  data?: IPasswordResetRequest
}

const ForgotPasswordForm: React.FC<IProps> = ({ onSubmit, data = {
  username: "",
} }: IProps) => {
  const { t } = useTranslation("common")

  return <Formik<IPasswordResetRequest> initialValues={data} onSubmit={onSubmit}>
    {({
      errors,
      handleSubmit,
      isSubmitting,
      values,
    }) => <Form onSubmit={handleSubmit}>
        <GeneralFormError
          errors={errors}
          prefix="user"
          excludeFields={["username"]}
        />
        <Field component={FormikInput}
          help="form.forgotPassword.usernameOrEmail.help"
          label="form.forgotPassword.usernameOrEmail.label"
          name="username"
          placeholder="form.forgotPassword.usernameOrEmail.placeholder"
          required
          value={values.username}
        />

        <p className="text-danger">{t("form.requiredFieldsHint")}</p>

        <FormButtonArea
          isSubmitting={isSubmitting}
          submitButton={{
            title: "form.forgotPassword.submit",
            iconName: "user",
          }}
        />
      </Form>
    }
  </Formik>
}

export default ForgotPasswordForm
